import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Load QA tools in development mode
import "./utils/productQA";

createRoot(document.getElementById("root")!).render(<App />);
